import React from "react";
import {Badge, Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, ListGroup, ListGroupItem, Row} from "reactstrap";
import {inject, observer} from "mobx-react";
import {Link} from "react-router-dom";
import Swal from "sweetalert2";
import getRoutes from "../../../components/Akitatek/getRoutes";

// Valeurs d'exemple pour l'aperçu : aucune donnée de client réel.
const EXEMPLE = {prenom: "Marie", nom: "Dupont", produit: "iPhone 12", dossier: "T261005001"};

/**
 * Modèles de SMS préparés à l'avance, avec variables ({prenom}, {produit}...) et aperçu en direct.
 */
const SmsTemplates = (inject("rootStore")(observer(class SmsTemplates extends React.Component {

    timer = null;
    textarea = React.createRef();

    get injected() {
        return this.props;
    }

    get store() {
        return this.injected.rootStore.smsStore;
    }

    constructor(props, context) {
        super(props, context);
        this.injected.rootStore.savedDatasStore.setHeader("Modèles de SMS", "Textes préparés à l'avance pour prévenir les clients", "default.jpg");
        this.state = {id: null, nom: "", contenu: "", exemple: {...EXEMPLE}, apercu: null};
    }

    componentDidMount() {
        this.store.getTemplates();
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    choisir(modele) {
        this.setState({id: modele.id, nom: modele.nom, contenu: modele.contenu}, () => this.apercu());
    }

    nouveau() {
        this.setState({id: null, nom: "", contenu: "", apercu: null});
    }

    insererVariable(nom) {
        const el = this.textarea.current;
        const texte = "{" + nom + "}";
        const debut = el ? el.selectionStart : this.state.contenu.length;
        const fin = el ? el.selectionEnd : this.state.contenu.length;
        const contenu = this.state.contenu.slice(0, debut) + texte + this.state.contenu.slice(fin);

        this.setState({contenu}, () => {
            if (el) {
                el.focus();
                el.selectionStart = el.selectionEnd = debut + texte.length;
            }
            this.apercu();
        });
    }

    changer(champ, valeur) {
        this.setState({[champ]: valeur}, () => this.apercu());
    }

    changerExemple(champ, valeur) {
        this.setState({exemple: {...this.state.exemple, [champ]: valeur}}, () => this.apercu());
    }

    apercu() {
        clearTimeout(this.timer);
        if (!this.state.contenu) {
            this.setState({apercu: null});
            return;
        }
        this.timer = setTimeout(async () => {
            const e = this.state.exemple;
            const apercu = await this.store.preview({
                contenu: this.state.contenu,
                valeurs: {...e, client: (e.prenom + " " + e.nom).trim()}
            });
            this.setState({apercu});
        }, 300);
    }

    async enregistrer() {
        const modele = await this.store.saveTemplate({id: this.state.id, nom: this.state.nom, contenu: this.state.contenu});
        if (modele) {
            this.setState({id: modele.id});
        }
    }

    async supprimer() {
        const result = await Swal.fire({
            title: "Supprimer ce modèle ?",
            text: this.state.nom,
            icon: "warning",
            confirmButtonText: "Supprimer",
            cancelButtonText: "Annuler",
            showCancelButton: true,
        });

        if (result.isConfirmed && await this.store.deleteTemplate(this.state.id)) {
            this.nouveau();
        }
    }

    render() {
        const store = this.store;
        const {apercu, exemple} = this.state;

        return (
            <Container className="mt-2" fluid>
                <Row>
                    <Col md="3">
                        <Card className="shadow mb-3">
                            <CardHeader style={{display: "flex", justifyContent: "space-between"}}>
                                <h4 className="mb-0">Modèles</h4>
                                <Button size="sm" color="primary" onClick={() => this.nouveau()}>Nouveau</Button>
                            </CardHeader>
                            <ListGroup flush>
                                {store.modeles.map(m => (
                                    <ListGroupItem key={m.id} action active={m.id === this.state.id} tag="button"
                                                   onClick={() => this.choisir(m)}>{m.nom}</ListGroupItem>
                                ))}
                            </ListGroup>
                            {store.modeles.length === 0 && <CardBody className="text-muted">Aucun modèle pour l'instant.</CardBody>}
                        </Card>
                        <Link to={getRoutes("Historique SMS")}><Button color="info" block>Historique des SMS</Button></Link>
                    </Col>

                    <Col md="5">
                        <Card className="shadow mb-3">
                            <CardHeader><h4 className="mb-0">{this.state.id ? "Modifier le modèle" : "Nouveau modèle"}</h4></CardHeader>
                            <CardBody>
                                <FormGroup>
                                    <Label>Nom du modèle</Label>
                                    <Input type="text" maxLength="100" value={this.state.nom} placeholder="Ex. : Appareil prêt à récupérer"
                                           onChange={e => this.changer("nom", e.target.value)}/>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Texte du SMS</Label>
                                    <Input type="textarea" rows="6" maxLength="1000" innerRef={this.textarea} value={this.state.contenu}
                                           placeholder="Bonjour {prenom}, votre {produit} est prêt. Vous pouvez le récupérer chez {magasin}. {horaires}"
                                           onChange={e => this.changer("contenu", e.target.value)}/>
                                    <small className="text-muted">{this.state.contenu.length} caractère(s)</small>
                                </FormGroup>
                                <p><small>Cliquez sur une variable pour l'insérer à l'endroit du curseur :</small></p>
                                <div className="mb-3">
                                    {Object.keys(store.variables).map(nom => (
                                        <Badge key={nom} color="info" className="mr-1 mb-1" title={store.variables[nom]}
                                               style={{cursor: "pointer"}} onClick={() => this.insererVariable(nom)}>{"{" + nom + "}"}</Badge>
                                    ))}
                                </div>
                                <Button color="success" onClick={() => this.enregistrer()}
                                        disabled={!this.state.nom || !this.state.contenu}>Enregistrer</Button>
                                {this.state.id && <Button color="danger" className="float-right" onClick={() => this.supprimer()}>Supprimer</Button>}
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md="4">
                        <Card className="shadow mb-3">
                            <CardHeader><h4 className="mb-0">Aperçu</h4></CardHeader>
                            <CardBody>
                                <p><small className="text-muted">Valeurs d'exemple (aucun vrai client) :</small></p>
                                <Row>
                                    {[["prenom", "Prénom"], ["nom", "Nom"], ["produit", "Produit"], ["dossier", "N° dossier"]].map(([champ, libelle]) => (
                                        <Col xs="6" key={champ}>
                                            <FormGroup>
                                                <Label><small>{libelle}</small></Label>
                                                <Input bsSize="sm" value={exemple[champ]} onChange={e => this.changerExemple(champ, e.target.value)}/>
                                            </FormGroup>
                                        </Col>
                                    ))}
                                </Row>
                                <div style={{whiteSpace: "pre-wrap", background: "#e8f5e9", borderRadius: "12px", padding: "12px 14px", minHeight: "60px"}}>
                                    {apercu ? apercu.texte : <span className="text-muted">Écrivez un texte pour voir l'aperçu.</span>}
                                </div>
                                {apercu && <p className="mt-2 mb-0"><small className="text-muted">
                                    {apercu.longueur} caractères — {apercu.nb_sms} SMS
                                </small></p>}
                                {apercu && apercu.nb_sms > 1 && <p className="text-warning mb-0"><small>
                                    Ce texte dépasse un SMS : il sera facturé {apercu.nb_sms} fois (les caractères comme œ, — ou les emojis raccourcissent un SMS à 70 caractères).
                                </small></p>}
                                {apercu && apercu.manquantes.length > 0 && <p className="text-danger mb-0"><small>
                                    Variable sans valeur : {apercu.manquantes.map(m => "{" + m + "}").join(", ")} (elle sera remplie au moment de l'envoi).
                                </small></p>}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
})));

export default SmsTemplates;
